import {Typography} from '@mui/material';
import Box from '@mui/material/Box';
import React from 'react';

type Props = {
  description: string
}

export const EmptyPageContent = ({description}: Props) => {
  return <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    height="100%"
    minHeight="300px"
    border={1}
    borderColor="divider"
    borderRadius={2}
    bgcolor="background.paper"
  >
    <Typography variant="body1" color="text.secondary">
      {description}
    </Typography>
  </Box>
}